<template>
  <div
    style="
      background-color: #f0f3f7;
      min-height: 100vh;
      padding: 10px 10px 0 10px;
      display: flex;
      align-items: center;
      flex-direction: column;
    "
  >


    <!-- 按钮标题 -->
    <div>
      <van-row type="flex" justify="space-between" style="flex-wrap: wrap">
        <van-col
          :span="item.span"
          class="flex-xc-yc"
          :style="
            'background-color: ' +
              item.color +
              ';border-radius: 4px;margin-top: 20px; height: 70px; padding: 6px 6px;'
          "
          v-for="(item, index) in WjtzDate"
          :key="index"
          @click="change(item.value)"
        >
          <div
            style="
              font-size: 12px;
              font-weight: 400;
              color: #fff;
              text-align: center;
            "
          >
            {{ item.text }}
          </div>
        </van-col>
      </van-row>
      <!-- <p style="font-size:20px;font-weight: bold;color: #ffffff;">综合报表</p> -->
    </div>

    <!-- 卡片标题显示 -->
    <van-row
      v-if="value1 > -1"
      type="flex"
      justify="center"
      style="flex-wrap: wrap; width: 90%; padding-bottom: 30px"
      class="month"
    >
      <template>
        <van-col
          v-for="(item, index) in WjtzDate.find(x => x.value == value1).children"
          :key="index"
          span="24"
          :style="
            `background-color: ${
              WjtzDate.find(x => x.value == value1).color
            };border-radius: 4px;margin-top: 20px; height: 38px; width: 85%; padding: 6px 6px;display:flex;flex-wrap:wrap;justify-content:center;align-item:center;`
          "
          @click="clickItem(item.value)"
        >
          <span
            style="
              font-size: 14px;
              font-weight: 400;
              color: #fff;
              padding-top: 3px;
            "
          >
            {{ item.text }}
          </span>
        </van-col>
      </template>
    </van-row>

    <!-- ==============图表============== -->
    <van-dialog
      v-model="isShowDiagram"
      :showConfirmButton="false"
      style="width: 95%; height: calc(100% - 90px)"
    >
    <!-- 标题 -->
      <div
        style="
          height: 35px;
          padding-top: 5px;
          font-size: x-large;
          color: cadetblue;
        "
      >
        {{ dataTitle }}
      </div>

      <!-- 表格和图表区 -->
      <div
        style="
          width: 100%;
          height: calc(100% - 80px);
          position: fixed;
          overflow: scroll;
        "
      >
        <div style="padding: 5px">
          <div
            class="flex-xb"
            style="color: #aaa; font-size: 12px; padding: 0.5em"
          >
            <span></span>
            <span>监测部门：{{ option.dept }}</span>
          </div>
          <Table
            v-if="!isNoData"
            :tableConfig="option.config"
            :tableData="option.data"
          ></Table>
        </div>
        <div
          v-show="isNoData"
          class="card1"
          style="height: 20px; color: darkgoldenrod"
        >
          暂无数据
        </div>
        <div
          v-show="!isNoData && !option.isChartHide"
          id="charts"
          style="width: 100%; height: 460px"
          class="card1"
        ></div>
        <div style="height: 50px; width: 50%"></div>
      </div>

      <!-- 关闭按钮区域 -->
      <div
        style="
          position: absolute;
          bottom: 0px;
          width: 100%;
          height: 45px;
          line-height: 45px;
          background-color: #007acc;
        "
        @click="clickItem(value2)"
      >
        关闭
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { deepClone } from '../utils/deepClone'
import Table from './custom/Table.vue'
let Echarts = require('echarts/lib/echarts') //基础实例 注意不要使用import
require('echarts/lib/component/toolbox')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/grid')
require('echarts/lib/component/legend')
require('echarts/lib/component/dataZoom')
require('echarts/lib/chart/bar')
require('echarts/lib/chart/line')

import { getWjtz } from '@/api/zdqd.js'
export default {
  name: 'wjtz1',
  components: { Table },

  data() {
    return {
      chart: null,
      isShowDiagram: false,
      xianying: 0,
      value1: -1,
      value2: 0,
      isNoData: true,
      dataTitle: '',
      option: {},
      // 稳进提质数据
      WjtzDate: [],

      //#region 
      // options: [
      //   {
      //     text: '综合报表',
      //     value: 0,
      //     span: 7,
      //     color: '#2ECCBD',
      //     children: [
      //       {
      //         text: '地区生产总值（GDP）',
      //         value: 100,
      //         dept: '发改局',
      //         xAxis: {
      //           data: ['1-3月', '1-6月', '1-7月', '1-8月']
      //         },
      //         yAxis: [
      //           { name: '总量(亿元)', max: 3000, interval: 200 },
      //           { name: '增速(%)', max: 15, interval: 3 }
      //         ],
      //         data: [
      //           {
      //             season: '1-3月',
      //             period: '1-3月',
      //             index: 1,
      //             blTotal: 585.7,
      //             blRate: 6.8,
      //             blRateStr: '6.8%',
      //             nbRate: 5.3,
      //             nbRateStr: '5.3%',
      //             zjRate: 5.1,
      //             zjRateStr: '5.1%',
      //             zjRank: ''
      //           },
      //           {
      //             season: '1-6月',
      //             period: '1-6月',
      //             index: 2,
      //             blTotal: 1219.2,
      //             blRate: 5.2,
      //             blRateStr: '5.2%',
      //             nbRate: 2.9,
      //             nbRateStr: '2.9%',
      //             zjRate: 2.5,
      //             zjRateStr: '2.5%',
      //             zjRank: '12'
      //           },
      //           {
      //             season: '1-7月',
      //             period: '1-7月',
      //             index: 2,
      //             blTotal: 1219.2,
      //             blRate: 5.2,
      //             blRateStr: '5.2%',
      //             nbRate: 2.9,
      //             nbRateStr: '2.9%',
      //             zjRate: 2.5,
      //             zjRateStr: '2.5%',
      //             zjRank: '12'
      //           },
      //           {
      //             season: '1-8月',
      //             period: '1-8月',
      //             index: 2,
      //             blTotal: 1219.2,
      //             blRate: 5.2,
      //             blRateStr: '5.2%',
      //             nbRate: 2.9,
      //             nbRateStr: '2.9%',
      //             zjRate: 2.5,
      //             zjRateStr: '2.5%',
      //             zjRank: '12'
      //           }
      //         ],
      //         config: {
      //           columns: [
      //             { text: '序号', key: 'index' },
      //             { text: '时间', key: 'period' },
      //             {
      //               text: '总量<br/>(亿元)',
      //               chartText: '总量',
      //               key: 'blTotal',
      //               type: 'bar',
      //               yAxisIndex: 0,
      //               unit: '亿元',
      //               color: '#1492FF'
      //             },
      //             {
      //               text: '增速',
      //               key: 'blRateStr',
      //               chartKey: 'blRate',
      //               type: 'line',
      //               yAxisIndex: 1,
      //               unit: '%',
      //               color: '#40de5a'
      //             },
      //             {
      //               text: '市增速',
      //               key: 'nbRateStr',
      //               chartKey: 'nbRate',
      //               type: 'line',
      //               yAxisIndex: 1,
      //               unit: '%',
      //               color: '#FC6F09'
      //             },
      //             {
      //               text: '省增速',
      //               key: 'zjRateStr',
      //               chartKey: 'zjRate',
      //               type: 'line',
      //               yAxisIndex: 1,
      //               unit: '%',
      //               color: '#7820bb'
      //             },
      //             { text: '省排名', key: 'zjRank' }
      //           ]
      //         }
      //       }
      //       // {
      //       //   text: '政策集成落地综合指数',
      //       //   value: 101,
      //       //   isHide: false,
      //       //   dept: '管委办',
      //       //   xAxis: {
      //       //     data: [
      //       //       '1-5月',
      //       //       '1-6月',
      //       //       '1-7月',
      //       //       '1-8月',
      //       //       '1-9月',
      //       //       '1-10月',
      //       //       '1-11月',
      //       //       '1-12月',
      //       //     ],
      //       //   },
      //       //   yAxis: [{ name: '指数', max: 100, interval: 10 }],
      //       //   data: [
      //       //     {
      //       //       period: '1-5月',
      //       //       index: 1,
      //       //       blNum: '',
      //       //       nbRank: '',
      //       //       zjRank: '',
      //       //     },
      //       //   ],
      //       //   config: {
      //       //     columns: [
      //       //       { text: '序号', key: 'index' },
      //       //       { text: '时间', key: 'period' },
      //       //       {
      //       //         text: '指数',
      //       //         key: 'blNum',
      //       //         type: 'bar',
      //       //         yAxisIndex: 0,
      //       //         unit: '',
      //       //         color: '#1492FF',
      //       //       },
      //       //       {
      //       //         text: '市排名',
      //       //         key: 'nbRank',
      //       //       },
      //       //       {
      //       //         text: '省排名',
      //       //         key: 'zjRank',
      //       //       },
      //       //     ],
      //       //   },
      //       // },
      //       // {
      //       //   text: '专项债券实际支出进度',
      //       //   value: 102,
      //       //   isHide: false,
      //       //   isChartHide: false,
      //       //   dept: '',
      //       //   xAxis: {
      //       //     data: [
      //       //       '1-5月',
      //       //       '1-6月',
      //       //       '1-7月',
      //       //       '1-8月',
      //       //       '1-9月',
      //       //       '1-10月',
      //       //       '1-11月',
      //       //       '1-12月',
      //       //     ],
      //       //   },
      //       //   yAxis: [{ name: '进度(%)', max: 50, interval: 5 }],
      //       //   data: [
      //       //     {
      //       //       period: '1-5月',
      //       //       index: 1,
      //       //       blProcess: 17.8,
      //       //       blProcessStr: '17.8%',
      //       //       zjRank: '',
      //       //     },
      //       //   ],
      //       //   config: {
      //       //     columns: [
      //       //       { text: '序号', key: 'index' },
      //       //       { text: '时间', key: 'period' },
      //       //       {
      //       //         text: '进度',
      //       //         key: 'blProcessStr',
      //       //         chartKey: 'blProcess',
      //       //         type: 'line',
      //       //         yAxisIndex: 0,
      //       //         unit: '%',
      //       //         color: '#1492FF',
      //       //       },
      //       //       { text: '省排名', key: 'zjRank' },
      //       //     ],
      //       //   },
      //       // },
      //     ]
      //   },
      //   {
      //     text: '投资报表',
      //     value: 1,
      //     span: 7,
      //     color: '#0A5AE5',
      //     children: [
      //       {
      //         text: '固定资产投资增速',
      //         value: 10,
      //         dept: '发改局',
      //         xAxis: {
      //           data: [
      //             '1-2月',
      //             '1-3月',
      //             '1-4月',
      //             '1-5月',
      //             '1-6月',
      //             '1-7月',
      //             '1-8月',
      //             '1-9月',
      //             '1-10月',
      //             '1-11月',
      //             '1-12月'
      //           ]
      //         },
      //         yAxis: [{ name: '增速(%)', max: 30, interval: 3 }],
      //         data: [
      //           {
      //             period: '1-2月',
      //             index: 1,
      //             blRate: 16.5,
      //             blRateStr: '16.5%',
      //             nbRate: 15.1,
      //             nbRateStr: '15.1%',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-3月',
      //             index: 2,
      //             blRate: 15.1,
      //             blRateStr: '15.1%',
      //             nbRate: 13.2,
      //             nbRateStr: '13.2%',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-4月',
      //             index: 3,
      //             blRate: 15.1,
      //             blRateStr: '15.1%',
      //             nbRate: 11.3,
      //             nbRateStr: '11.3%',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-5月',
      //             index: 4,
      //             blRate: 15.7,
      //             blRateStr: '15.7%',
      //             nbRate: 10.8,
      //             nbRateStr: '10.8%',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-6月',
      //             index: 5,
      //             blRate: 14.3,
      //             blRateStr: '14.3%',
      //             nbRate: 10.3,
      //             nbRateStr: '10.3%',
      //             zjRank: '33'
      //           },
      //           {
      //             period: '1-7月',
      //             index: 5,
      //             blRate: 14.8,
      //             blRateStr: '14.8%',
      //             nbRate: 10.4,
      //             nbRateStr: '10.4%',
      //             zjRank: '25'
      //           },
      //           {
      //             period: '1-8月',
      //             index: 6,
      //             blRate: 14.6,
      //             blRateStr: '14.6%',
      //             nbRate: 14.6,
      //             nbRateStr: '10.4%',
      //             zjRank: '25'
      //           }
      //         ],
      //         config: {
      //           columns: [
      //             { text: '序号', key: 'index' },
      //             { text: '时间', key: 'period' },
      //             {
      //               text: '增速',
      //               key: 'blRateStr',
      //               chartKey: 'blRate',
      //               type: 'line',
      //               yAxisIndex: 0,
      //               unit: '%',
      //               color: '#40de5a'
      //             },
      //             {
      //               text: '市增速',
      //               key: 'nbRateStr',
      //               chartKey: 'nbRate',
      //               type: 'line',
      //               yAxisIndex: 0,
      //               unit: '%',
      //               color: '#FC6F09'
      //             },
      //             { text: '省排名', key: 'zjRank' }
      //           ]
      //         }
      //       },
      //       {
      //         text: '民间项目投资增速',
      //         value: 11,
      //         dept: '发改局',
      //         xAxis: {
      //           data: [
      //             '1-2月',
      //             '1-3月',
      //             '1-4月',
      //             '1-5月',
      //             '1-6月',
      //             '1-7月',
      //             '1-8月',
      //             '1-9月',
      //             '1-10月',
      //             '1-11月',
      //             '1-12月'
      //           ]
      //         },
      //         yAxis: [
      //           {
      //             name: '增速(%)',
      //             min: -6,
      //             max: 30,
      //             interval: 3
      //           }
      //         ],
      //         data: [
      //           {
      //             period: '1-2月',
      //             index: 1,
      //             blRate: 14.0,
      //             blRateStr: '14.0%',
      //             nbRate: 9.3,
      //             nbRateStr: '9.3%',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-3月',
      //             index: 2,
      //             blRate: 18.7,
      //             blRateStr: '18.7%',
      //             nbRate: 7.9,
      //             nbRateStr: '7.9%',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-4月',
      //             index: 3,
      //             blRate: 18.8,
      //             blRateStr: '18.8%',
      //             nbRate: 5.3,
      //             nbRateStr: '5.3%',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-5月',
      //             index: 4,
      //             blRate: 10.0,
      //             blRateStr: '10.0%',
      //             nbRate: 2.0,
      //             nbRateStr: '2.0%',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-6月',
      //             index: 5,
      //             blRate: -3.1,
      //             blRateStr: '-3.1%',
      //             nbRate: 16.2,
      //             nbRateStr: '16.2%',
      //             zjRank: '72'
      //           },
      //           {
      //             period: '1-7月',
      //             index: 5,
      //             blRate: -6.2,
      //             blRateStr: '-6.2%',
      //             nbRate: 10.7,
      //             nbRateStr: '10.7%',
      //             zjRank: '80'
      //           },
      //           {
      //             period: '1-8月',
      //             index: 6,
      //             blRate: 0.4,
      //             blRateStr: '0.4%',
      //             nbRate: 12,
      //             nbRateStr: '12%',
      //             zjRank: '69'
      //           }
      //         ],
      //         config: {
      //           columns: [
      //             { text: '序号', key: 'index' },
      //             { text: '时间', key: 'period' },
      //             {
      //               text: '增速',
      //               key: 'blRateStr',
      //               chartKey: 'blRate',
      //               type: 'line',
      //               yAxisIndex: 0,
      //               unit: '%',
      //               color: '#40de5a'
      //             },
      //             {
      //               text: '市增速',
      //               key: 'nbRateStr',
      //               chartKey: 'nbRate',
      //               type: 'line',
      //               yAxisIndex: 0,
      //               unit: '%',
      //               color: '#FC6F09'
      //             },
      //             { text: '省排名', key: 'zjRank' }
      //           ]
      //         }
      //       },
      //       {
      //         text: '省重大项目投资完成率',
      //         value: 12,
      //         dept: '发改局',
      //         xAxis: {
      //           data: [
      //             '1-5月',
      //             '1-6月',
      //             '1-7月',
      //             '1-8月',
      //             '1-9月',
      //             '1-10月',
      //             '1-11月',
      //             '1-12月'
      //           ]
      //         },
      //         yAxis: [{ name: '完成率(%)', max: 120 }],
      //         data: [
      //           {
      //             period: '1-5月',
      //             index: 1,
      //             blComplete: 58.1,
      //             blCompleteStr: '58.1%',
      //             nbRate: '',
      //             nbRateStr: '',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-6月',
      //             index: 2,
      //             blComplete: 94.4,
      //             blCompleteStr: '94.4%',
      //             nbRate: 65.1,
      //             nbRateStr: '65.1%',
      //             zjRank: '25'
      //           },
      //           {
      //             period: '1-7月',
      //             index: 5,
      //             blComplete: 102.8,
      //             blCompleteStr: '102.8%',
      //             nbRate: 89.5,
      //             nbRateStr: '89.5%',
      //             zjRank: '29'
      //           },
      //           {
      //             period: '1-8月',
      //             index: 6,
      //             blComplete: 113.8,
      //             blCompleteStr: '113.8%',
      //             nbRate: '/',
      //             nbRateStr: '/',
      //             zjRank: '25'
      //           }
      //         ],
      //         config: {
      //           columns: [
      //             { text: '序号', key: 'index' },
      //             { text: '时间', key: 'period' },
      //             {
      //               text: '完成率',
      //               key: 'blCompleteStr',
      //               chartKey: 'blComplete',
      //               type: 'line',
      //               yAxisIndex: 0,
      //               unit: '%',
      //               color: '#40de5a'
      //             },
      //             {
      //               text: '市增速',
      //               key: 'nbRateStr',
      //               chartKey: 'nbRate',
      //               type: 'line',
      //               yAxisIndex: 0,
      //               unit: '%',
      //               color: '#FC6F09'
      //             },
      //             { text: '省排名', key: 'zjRank' }
      //           ]
      //         }
      //       },
      //       {
      //         text: '省重大项目新建项目开工率',
      //         value: 13,
      //         dept: '发改局',
      //         xAxis: {
      //           data: [
      //             '1-5月',
      //             '1-6月',
      //             '1-7月',
      //             '1-8月',
      //             '1-9月',
      //             '1-10月',
      //             '1-11月',
      //             '1-12月'
      //           ]
      //         },
      //         yAxis: [{ name: '完成率(%)', max: 80, interval: 8 }],
      //         data: [
      //           {
      //             period: '1-5月',
      //             index: 1,
      //             blComplete: 40.0,
      //             blCompleteStr: '40.0%',
      //             nbRate: '',
      //             nbRateStr: '',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-6月',
      //             index: 2,
      //             blComplete: 66.7,
      //             blCompleteStr: '66.7%',
      //             nbRate: 63.9,
      //             nbRateStr: '63.9%',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-7月',
      //             index: 5,
      //             blComplete: 66.7,
      //             blCompleteStr: '66.7%',
      //             nbRate: 86.1,
      //             nbRateStr: '86.1%',
      //             zjRank: '61'
      //           },

      //           {
      //             period: '1-8月',
      //             index: 6,
      //             blComplete: 83.4,
      //             blCompleteStr: '83.4%',
      //             nbRate: '/',
      //             nbRateStr: '/',
      //             zjRank: '63'
      //           }
      //         ],
      //         config: {
      //           columns: [
      //             { text: '序号', key: 'index' },
      //             { text: '时间', key: 'period' },
      //             {
      //               text: '完成率',
      //               key: 'blCompleteStr',
      //               chartKey: 'blComplete',
      //               type: 'line',
      //               yAxisIndex: 0,
      //               unit: '%',
      //               color: '#40de5a'
      //             },
      //             {
      //               text: '市增速',
      //               key: 'nbRateStr',
      //               chartKey: 'nbRate',
      //               type: 'line',
      //               yAxisIndex: 0,
      //               unit: '%',
      //               color: '#FC6F09'
      //             },
      //             { text: '省排名', key: 'zjRank' }
      //           ]
      //         }
      //       },
      //       {
      //         text: '2年内立项项目开工率',
      //         value: 14,
      //         dept: '发改局',
      //         xAxis: {
      //           data: [
      //             '1-5月',
      //             '1-6月',
      //             '1-7月',
      //             '1-8月',
      //             '1-9月',
      //             '1-10月',
      //             '1-11月',
      //             '1-12月'
      //           ]
      //         },
      //         yAxis: [{ name: '完成率(%)', max: 100, interval: 10 }],
      //         data: [
      //           {
      //             period: '1-5月',
      //             index: 1,
      //             blComplete: 71.0,
      //             blCompleteStr: '71.0%',
      //             nbRate: '',
      //             nbRateStr: '',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-6月',
      //             index: 2,
      //             blComplete: 82.2,
      //             blCompleteStr: '82.2%',
      //             nbRate: 81.6,
      //             nbRateStr: '81.6%',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-7月',
      //             index: 5,
      //             blComplete: 84.7,
      //             blCompleteStr: '84.7%',
      //             nbRate: 85,
      //             nbRateStr: '85%',
      //             zjRank: '76'
      //           },
      //           {
      //             period: '1-8月',
      //             index: 6,
      //             blComplete: 92,
      //             blCompleteStr: '92%',
      //             nbRate: '/',
      //             nbRateStr: '/',
      //             zjRank: '36'
      //           }
      //         ],
      //         config: {
      //           columns: [
      //             { text: '序号', key: 'index' },
      //             { text: '时间', key: 'period' },
      //             {
      //               text: '完成率',
      //               key: 'blCompleteStr',
      //               chartKey: 'blComplete',
      //               type: 'line',
      //               yAxisIndex: 0,
      //               unit: '%',
      //               color: '#40de5a'
      //             },
      //             {
      //               text: '市增速',
      //               key: 'nbRateStr',
      //               chartKey: 'nbRate',
      //               type: 'line',
      //               yAxisIndex: 0,
      //               unit: '%',
      //               color: '#FC6F09'
      //             },
      //             { text: '省排名', key: 'zjRank' }
      //           ]
      //         }
      //       }
      //     ]
      //   },
      //   {
      //     text: '工业报表',
      //     value: 2,
      //     span: 7,
      //     color: '#F37343',
      //     children: [
      //       {
      //         text: '规上工业增加值增速',
      //         value: 20,
      //         dept: '经信局',
      //         xAxis: {
      //           data: [
      //             '1-2月',
      //             '1-3月',
      //             '1-4月',
      //             '1-5月',
      //             '1-6月',
      //             '1-7月',
      //             '1-8月',
      //             '1-9月',
      //             '1-10月',
      //             '1-11月',
      //             '1-12月'
      //           ]
      //         },
      //         yAxis: [
      //           { name: '总量(亿元)', max: 3000, interval: 200 },
      //           { name: '增速(%)', max: 15, interval: 3 }
      //         ],
      //         data: [
      //           {
      //             period: '1-2月',
      //             index: 1,
      //             blTotal: 186.2,
      //             blRate: 9.3,
      //             blRateStr: '9.3%',
      //             nbRate: 8.7,
      //             nbRateStr: '8.7%',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-3月',
      //             index: 2,
      //             blTotal: 305.4,
      //             blRate: 10.6,
      //             blRateStr: '10.6%',
      //             nbRate: 8.5,
      //             nbRateStr: '8.5%',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-4月',
      //             index: 3,
      //             blTotal: 402.9,
      //             blRate: 9.7,
      //             blRateStr: '9.7%',
      //             nbRate: 5.7,
      //             nbRateStr: '5.7%',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-5月',
      //             index: 4,
      //             blTotal: 501.1,
      //             blRate: 8.2,
      //             blRateStr: '8.2%',
      //             nbRate: 4.9,
      //             nbRateStr: '4.9%',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-6月',
      //             index: 5,
      //             blTotal: 612.7,
      //             blRate: 7.9,
      //             blRateStr: '7.9%',
      //             nbRate: 5.0,
      //             nbRateStr: '5.0%',
      //             zjRank: '24'
      //           },
      //           {
      //             period: '1-7月',
      //             index: 5,
      //             blTotal: '/',
      //             blRate: 7.2,
      //             blRateStr: '7.2%',
      //             nbRate: 4.8,
      //             nbRateStr: '4.8%',
      //             zjRank: '29'
      //           },
      //           {
      //             period: '1-8月',
      //             index: 6,
      //             blTotal: '/',
      //             blRate: 6.9,
      //             blRateStr: '6.9%',
      //             nbRate: 4.8,
      //             nbRateStr: '4.8%',
      //             zjRank: '30'
      //           }
      //         ],
      //         config: {
      //           columns: [
      //             { text: '序号', key: 'index' },
      //             { text: '时间', key: 'period' },
      //             {
      //               text: '总量<br/>(亿元)',
      //               chartText: '总量',
      //               key: 'blTotal',
      //               type: 'bar',
      //               yAxisIndex: 0,
      //               unit: '亿元',
      //               color: '#1492FF'
      //             },
      //             {
      //               text: '增速',
      //               key: 'blRateStr',
      //               chartKey: 'blRate',
      //               type: 'line',
      //               yAxisIndex: 1,
      //               unit: '%',
      //               color: '#40de5a'
      //             },
      //             {
      //               text: '市增速',
      //               key: 'nbRateStr',
      //               chartKey: 'nbRate',
      //               type: 'line',
      //               yAxisIndex: 1,
      //               unit: '%',
      //               color: '#FC6F09'
      //             },
      //             { text: '省排名', key: 'zjRank' }
      //           ]
      //         }
      //       },
      //       {
      //         text: '制造业投资增速',
      //         value: 21,
      //         dept: '经信局',
      //         xAxis: {
      //           data: [
      //             '1-2月',
      //             '1-3月',
      //             '1-4月',
      //             '1-5月',
      //             '1-6月',
      //             '1-7月',
      //             '1-8月',
      //             '1-9月',
      //             '1-10月',
      //             '1-11月',
      //             '1-12月'
      //           ]
      //         },
      //         yAxis: [{ name: '增速(%)', max: 50, interval: 5 }],
      //         data: [
      //           {
      //             period: '1-2月',
      //             index: 1,
      //             blRate: 20.9,
      //             blRateStr: '20.9%',
      //             nbRate: 26.4,
      //             nbRateStr: '26.4%',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-3月',
      //             index: 2,
      //             blRate: 2.0,
      //             blRateStr: '2.0%',
      //             nbRate: 19.1,
      //             nbRateStr: '19.1%',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-4月',
      //             index: 3,
      //             blRate: 1.5,
      //             blRateStr: '1.5%',
      //             nbRate: 12.4,
      //             nbRateStr: '12.4%',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-5月',
      //             index: 4,
      //             blRate: 1.9,
      //             blRateStr: '1.9%',
      //             nbRate: 10.4,
      //             nbRateStr: '10.4%',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-6月',
      //             index: 5,
      //             blRate: 4.3,
      //             blRateStr: '4.3%',
      //             nbRate: 10.4,
      //             nbRateStr: '10.4%',
      //             zjRank: '77'
      //           },
      //           {
      //             period: '1-7月',
      //             index: 6,
      //             blRate: 3,
      //             blRateStr: '3%',
      //             nbRate: 13.3,
      //             nbRateStr: '13.3%',
      //             zjRank: '78'
      //           },
      //           {
      //             period: '1-8月',
      //             index: 7,
      //             blRate: 3.4,
      //             blRateStr: '3.4%',
      //             nbRate: 13.9,
      //             nbRateStr: '13.9%',
      //             zjRank: '77'
      //           }
      //         ],
      //         config: {
      //           columns: [
      //             { text: '序号', key: 'index' },
      //             { text: '时间', key: 'period' },
      //             {
      //               text: '增速',
      //               key: 'blRateStr',
      //               chartKey: 'blRate',
      //               type: 'line',
      //               yAxisIndex: 0,
      //               unit: '%',
      //               color: '#40de5a'
      //             },
      //             {
      //               text: '市增速',
      //               key: 'nbRateStr',
      //               chartKey: 'nbRate',
      //               type: 'line',
      //               yAxisIndex: 0,
      //               unit: '%',
      //               color: '#FC6F09'
      //             },
      //             { text: '省排名', key: 'zjRank' }
      //           ]
      //         }
      //       },
      //       {
      //         text: '产业链预警畅链指数',
      //         value: 23,
      //         isHide: false,
      //         dept: '经信局',
      //         xAxis: {
      //           data: [
      //             '1-2月',
      //             '1-3月',
      //             '1-4月',
      //             '1-5月',
      //             '1-6月',
      //             '1-7月',
      //             '1-8月',
      //             '1-9月',
      //             '1-10月',
      //             '1-11月',
      //             '1-12月'
      //           ]
      //         },
      //         yAxis: [{ name: '指数', max: 50, interval: 5 }],
      //         data: [
      //           {
      //             period: '1-2月',
      //             index: 1,
      //             blProcess: '',
      //             blProcessStr: '',
      //             zjRank: '16'
      //           },

      //           {
      //             period: '1-7月',
      //             index: 5,
      //             blProcess: '/',
      //             blProcessStr: '/',
      //             zjRank: '8'
      //           },
      //           {
      //             period: '1-8月',
      //             index: 6,
      //             blProcess: '/',
      //             blProcessStr: '/',
      //             zjRank: '2'
      //           }
      //         ],
      //         config: {
      //           columns: [
      //             { text: '序号', key: 'index' },
      //             { text: '时间', key: 'period' },
      //             {
      //               text: '指数',
      //               key: 'blProcessStr',
      //               chartKey: 'blProcess',
      //               type: 'line',
      //               yAxisIndex: 0,
      //               unit: '%',
      //               color: '#1492FF'
      //             },
      //             { text: '省排名', key: 'zjRank' }
      //           ]
      //         }
      //       }
      //     ]
      //   },
      //   {
      //     text: '“两稳一促”报表',
      //     value: 3,
      //     span: 11,
      //     color: '#55A9FF',
      //     children: [
      //       {
      //         text: '出口增速',
      //         value: 30,
      //         dept: '商务局',
      //         xAxis: {
      //           data: [
      //             '1-2月',
      //             '1-3月',
      //             '1-4月',
      //             '1-5月',
      //             '1-6月',
      //             '1-7月',
      //             '1-8月',
      //             '1-9月',
      //             '1-10月',
      //             '1-11月',
      //             '1-12月'
      //           ]
      //         },
      //         yAxis: [{ name: '增速(%)', max: 50, interval: 5 }],
      //         data: [
      //           {
      //             period: '1-2月',
      //             index: 1,
      //             blRate: 21.6,
      //             blRateStr: '21.6%',
      //             nbRate: 21.3,
      //             nbRateStr: '21.3%',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-3月',
      //             index: 2,
      //             blRate: 17.7,
      //             blRateStr: '17.7%',
      //             nbRate: 20.4,
      //             nbRateStr: '20.4%',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-4月',
      //             index: 3,
      //             blRate: 14.2,
      //             blRateStr: '14.2%',
      //             nbRate: 16.6,
      //             nbRateStr: '16.6%',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-5月',
      //             index: 4,
      //             blRate: 14.3,
      //             blRateStr: '14.3%',
      //             nbRate: 14.9,
      //             nbRateStr: '14.9%',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-6月',
      //             index: 5,
      //             blRate: 14.7,
      //             blRateStr: '14.7%',
      //             nbRate: 14.1,
      //             nbRateStr: '14.1%',
      //             zjRank: '59'
      //           },
      //           {
      //             period: '1-7月',
      //             index: 5,
      //             blRate: 16.9,
      //             blRateStr: '16.9%',
      //             nbRate: 16.1,
      //             nbRateStr: '16.1%',
      //             zjRank: '63'
      //           },
      //           {
      //             period: '1-8月',
      //             index: 6,
      //             blTotal: '/',
      //             blRate: 16.4,
      //             blRateStr: '16.4%',
      //             nbRate: 14.9,
      //             nbRateStr: '14.9%',
      //             zjRank: '62'
      //           }
      //         ],
      //         config: {
      //           columns: [
      //             { text: '序号', key: 'index' },
      //             { text: '时间', key: 'period' },
      //             {
      //               text: '增速',
      //               key: 'blRateStr',
      //               chartKey: 'blRate',
      //               type: 'line',
      //               yAxisIndex: 0,
      //               unit: '%',
      //               color: '#40de5a'
      //             },
      //             {
      //               text: '市增速',
      //               key: 'nbRateStr',
      //               chartKey: 'nbRate',
      //               type: 'line',
      //               yAxisIndex: 0,
      //               unit: '%',
      //               color: '#FC6F09'
      //             },
      //             { text: '省排名', key: 'zjRank' }
      //           ]
      //         }
      //       },
      //       {
      //         text: '出口份额变化情况',
      //         value: 31,
      //         isHide: false,
      //         dept: '商务局',
      //         xAxis: {
      //           data: [
      //             '1-2月',
      //             '1-3月',
      //             '1-4月',
      //             '1-5月',
      //             '1-6月',
      //             '1-7月',
      //             '1-8月',
      //             '1-9月',
      //             '1-10月',
      //             '1-11月',
      //             '1-12月'
      //           ]
      //         },
      //         yAxis: [{ name: '占比(‰)', max: 1, interval: 0.1 }],
      //         data: [
      //           {
      //             period: '1-2月',
      //             index: 1,
      //             zgRatio: 0.53,
      //             zgRatioStr: '↑0.53‰',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-3月',
      //             index: 2,
      //             zgRatio: 0.31,
      //             zgRatioStr: '↑0.31‰',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-4月',
      //             index: 3,
      //             zgRatio: 0.3,
      //             zgRatioStr: '↑0.30‰',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-5月',
      //             index: 4,
      //             zgRatio: 0.11,
      //             zgRatioStr: '↑0.11‰',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-6月',
      //             index: 5,
      //             zgRatio: 0.23,
      //             zgRatioStr: '↑0.23‰',
      //             zjRank: '32'
      //           },
      //           {
      //             period: '1-7月',
      //             index: 6,
      //             zgRatio: 0.17,
      //             zgRatioStr: '↑0.17‰',
      //             zjRank: '22'
      //           },
      //           {
      //             period: '1-8月',
      //             index: 7,
      //             zgRatio: 0.16,
      //             zgRatioStr: '↑0.16‰',
      //             zjRank: '21'
      //           }
      //         ],
      //         config: {
      //           columns: [
      //             { text: '序号', key: 'index' },
      //             { text: '时间', key: 'period' },
      //             {
      //               text: '占全国份额变化',
      //               key: 'zgRatioStr',
      //               chartKey: 'zgRatio',
      //               type: 'line',
      //               yAxisIndex: 0,
      //               unit: '%',
      //               color: '#40de5a'
      //             },
      //             { text: '省排名', key: 'zjRank' }
      //           ]
      //         }
      //       },
      //       {
      //         text: '进口增速',
      //         value: 32,
      //         dept: '商务局',
      //         xAxis: {
      //           data: [
      //             '1-2月',
      //             '1-3月',
      //             '1-4月',
      //             '1-5月',
      //             '1-6月',
      //             '1-7月',
      //             '1-8月',
      //             '1-9月',
      //             '1-10月',
      //             '1-11月',
      //             '1-12月'
      //           ]
      //         },
      //         yAxis: [{ name: '增速(%)', max: 50, interval: 5 }],
      //         data: [
      //           {
      //             period: '1-2月',
      //             index: 1,
      //             blRate: 5.2,
      //             blRateStr: '5.2%',
      //             nbRate: 16.5,
      //             nbRateStr: '16.5%',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-3月',
      //             index: 2,
      //             blRate: 6.9,
      //             blRateStr: '6.9%',
      //             nbRate: 11.4,
      //             nbRateStr: '11.4%',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-4月',
      //             index: 3,
      //             blRate: 1.6,
      //             blRateStr: '1.6%',
      //             nbRate: 5.7,
      //             nbRateStr: '5.7%',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-5月',
      //             index: 4,
      //             blRate: 2.3,
      //             blRateStr: '2.3%',
      //             nbRate: 5.7,
      //             nbRateStr: '5.7%',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-6月',
      //             index: 5,
      //             blRate: 4.7,
      //             blRateStr: '4.7%',
      //             nbRate: 8.1,
      //             nbRateStr: '8.1%',
      //             zjRank: '49'
      //           },
      //           {
      //             period: '1-7月',
      //             index: 5,
      //             blRate: 6.5,
      //             blRateStr: '6.5%',
      //             nbRate: 8.5,
      //             nbRateStr: '8.5%',
      //             zjRank: '46'
      //           },
      //           {
      //             period: '1-8月',
      //             index: 6,
      //             blTotal: '/',
      //             blRate: 6.6,
      //             blRateStr: '6.6%',
      //             nbRate: 7.8,
      //             nbRateStr: '7.8%',
      //             zjRank: '45'
      //           }
      //         ],
      //         config: {
      //           columns: [
      //             { text: '序号', key: 'index' },
      //             { text: '时间', key: 'period' },
      //             {
      //               text: '增速',
      //               key: 'blRateStr',
      //               chartKey: 'blRate',
      //               type: 'line',
      //               yAxisIndex: 0,
      //               unit: '%',
      //               color: '#40de5a'
      //             },
      //             {
      //               text: '市增速',
      //               key: 'nbRateStr',
      //               chartKey: 'nbRate',
      //               type: 'line',
      //               yAxisIndex: 0,
      //               unit: '%',
      //               color: '#FC6F09'
      //             },
      //             { text: '省排名', key: 'zjRank' }
      //           ]
      //         }
      //       },
      //       {
      //         text: '实际利用外资',
      //         value: 33,
      //         dept: '投合局',
      //         xAxis: {
      //           data: [
      //             '1-2月',
      //             '1-3月',
      //             '1-4月',
      //             '1-5月',
      //             '1-6月',
      //             '1-7月',
      //             '1-8月',
      //             '1-9月',
      //             '1-10月',
      //             '1-11月',
      //             '1-12月'
      //           ]
      //         },
      //         yAxis: [{ name: '总量(亿美元)', max: 15, interval: 1 }],
      //         data: [
      //           {
      //             period: '1-2月',
      //             index: 1,
      //             blTotal: 4.06,
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-3月',
      //             index: 2,
      //             blTotal: 5.69,
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-4月',
      //             index: 3,
      //             blTotal: 5.71,
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-5月',
      //             index: 4,
      //             blTotal: 5.85,
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-6月',
      //             index: 5,
      //             blTotal: 8.15,
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-7月',
      //             index: 5,
      //             blTotal: 10.4,
      //             zjRank: '1'
      //           },
      //           {
      //             period: '1-8月',
      //             index: 5,
      //             blTotal: 11.3,
      //             zjRank: '2'
      //           }
      //         ],
      //         config: {
      //           columns: [
      //             { text: '序号', key: 'index' },
      //             { text: '时间', key: 'period' },
      //             {
      //               text: '总量<br/>(亿美元)',
      //               chartText: '总量',
      //               key: 'blTotal',
      //               type: 'bar',
      //               yAxisIndex: 0,
      //               unit: '亿美元',
      //               color: '#1492FF'
      //             },
      //             { text: '省排名', key: 'zjRank' }
      //           ]
      //         }
      //       },
      //       {
      //         text: '社会消费品零售总额增速',
      //         value: 34,
      //         dept: '商务局',
      //         xAxis: {
      //           data: [
      //             '1-2月',
      //             '1-3月',
      //             '1-4月',
      //             '1-5月',
      //             '1-6月',
      //             '1-7月',
      //             '1-8月',
      //             '1-9月',
      //             '1-10月',
      //             '1-11月',
      //             '1-12月'
      //           ]
      //         },
      //         yAxis: [{ name: '增速(%)', min: -10, max: 20, interval: 3 }],
      //         data: [
      //           {
      //             period: '1-2月',
      //             index: 1,
      //             blRate: 9.7,
      //             blRateStr: '9.7%',
      //             nbRate: 6.3,
      //             nbRateStr: '6.3%',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-3月',
      //             index: 2,
      //             blRate: 4.0,
      //             blRateStr: '4.0%',
      //             nbRate: 5.9,
      //             nbRateStr: '5.9%',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-4月',
      //             index: 3,
      //             blRate: -1.7,
      //             blRateStr: '-1.7%',
      //             nbRate: 0.2,
      //             nbRateStr: '0.2%',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-5月',
      //             index: 4,
      //             blRate: -1.9,
      //             blRateStr: '-1.9%',
      //             nbRate: -0.6,
      //             nbRateStr: '-0.6%',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-6月',
      //             index: 5,
      //             blRate: 1.9,
      //             blRateStr: '1.9%',
      //             nbRate: 2.4,
      //             nbRateStr: '2.4%',
      //             zjRank: '47'
      //           },
      //           {
      //             period: '1-7月',
      //             index: 5,
      //             blRate: 4.0,
      //             blRateStr: '4.0%',
      //             nbRate: 3.9,
      //             nbRateStr: '3.9%',
      //             zjRank: '37'
      //           },
      //           {
      //             period: '1-8月',
      //             index: 6,
      //             blTotal: '/',
      //             blRate: 5.6,
      //             blRateStr: '5.6%',
      //             nbRate: 5,
      //             nbRateStr: '5%',
      //             zjRank: '32'
      //           }
      //         ],
      //         config: {
      //           columns: [
      //             { text: '序号', key: 'index' },
      //             { text: '时间', key: 'period' },
      //             {
      //               text: '增速',
      //               key: 'blRateStr',
      //               chartKey: 'blRate',
      //               type: 'line',
      //               yAxisIndex: 0,
      //               unit: '%',
      //               color: '#40de5a'
      //             },
      //             {
      //               text: '市增速',
      //               key: 'nbRateStr',
      //               chartKey: 'nbRate',
      //               type: 'line',
      //               yAxisIndex: 0,
      //               unit: '%',
      //               color: '#FC6F09'
      //             },
      //             { text: '省排名', key: 'zjRank' }
      //           ]
      //         }
      //       }
      //     ]
      //   },
      //   {
      //     text: '市场活力报表',
      //     value: 4,
      //     span: 11,
      //     color: '#a29bfe',
      //     children: [
      //       {
      //         text: '市场主体变化情况',
      //         value: 40,
      //         isHide: false,
      //         dept: '市场监管局',
      //         xAxis: {
      //           data: [
      //             '1-5月',
      //             '1-7月',
      //             '1-8月',
      //             '1-9月',
      //             '1-10月',
      //             '1-11月',
      //             '1-12月'
      //           ]
      //         },
      //         yAxis: [{ name: '加权得分', max: 100, interval: 10 }],
      //         data: [
      //           {
      //             period: '1-5月',
      //             index: 1,
      //             blWeightScore: '9.96',
      //             nbRate: 8.95,
      //             nbRateStr: '8.95%',
      //             zjRank: '1'
      //           },
      //           {
      //             period: '1-6月',
      //             index: 2,
      //             blWeightScore: '/',
      //             nbRate: 8.95,
      //             nbRateStr: '8.95',
      //             zjRank: '1'
      //           },
      //           {
      //             period: '1-7月',
      //             index: 2,
      //             blWeightScore: '/',
      //             nbRate: 8.07,
      //             nbRateStr: '8.07',
      //             zjRank: '1'
      //           },
      //           {
      //             period: '1-8月',
      //             index: 2,
      //             blWeightScore: '/',
      //             nbRate: 8.07,
      //             nbRateStr: '8.07',
      //             zjRank: '1'
      //           }
      //         ],
      //         config: {
      //           columns: [
      //             { text: '序号', key: 'index' },
      //             { text: '时间', key: 'period' },
      //             {
      //               text: '增速',
      //               key: 'blWeightScore',
      //               type: 'line',
      //               yAxisIndex: 0,
      //               unit: '%',
      //               color: '#1492FF'
      //             },
      //             {
      //               text: '市增速',
      //               key: 'nbRateStr',
      //               chartKey: 'nbRate',
      //               type: 'line',
      //               yAxisIndex: 0,
      //               unit: '%',
      //               color: '#FC6F09'
      //             },
      //             { text: '省排名', key: 'zjRank' }
      //           ]
      //         }
      //       },
      //       {
      //         text: '接待游客人次同比增速',
      //         value: 43,
      //         isHide: false,
      //         dept: '文广旅体局',
      //         xAxis: { data: ['1-3月', '1-6月', '1-7月', '1-8月'] },
      //         yAxis: [{ name: '增速(%)', min: -20, max: 10, interval: 2 }],
      //         data: [
      //           {
      //             period: '1-3月',
      //             index: 1,
      //             blRate: '',
      //             blRateStr: '',
      //             zjRank: ''
      //           },
      //           {
      //             period: '1-6月',
      //             index: 2,
      //             blRate: -14.3,
      //             blRateStr: '-14.3%',
      //             zjRank: '30'
      //           },
      //           {
      //             period: '1-7月',
      //             index: 3,
      //             blRate: 2.0,
      //             blRateStr: '2.0%',
      //             zjRank: '60'
      //           },
      //           {
      //             period: '1-8月',
      //             index: 4,
      //             blRate: 6.7,
      //             blRateStr: '6.7%',
      //             zjRank: '34'
      //           }
      //         ],
      //         config: {
      //           columns: [
      //             { text: '序号', key: 'index' },
      //             { text: '时间', key: 'period' },
      //             {
      //               text: '增速',
      //               key: 'blRateStr',
      //               chartKey: 'blRate',
      //               type: 'line',
      //               yAxisIndex: 0,
      //               unit: '%',
      //               color: '#40de5a'
      //             },
      //             { text: '省排名', key: 'zjRank' }
      //           ]
      //         }
      //       }
      //     ]
      //   },
      //   {
      //     text: '要素保障报表',
      //     color: '#EAB543',
      //     value: 5,
      //     span: 11,
      //     children: [
      //       {
      //         text: '要素保障“目标达成率”指数',
      //         value: 51,
      //         dept: '区发改局',
      //         xAxis: {
      //           data: ['1-6月', '1-7月', '1-8月']
      //         },
      //         yAxis: [{ name: '增速(%)', max: 100, interval: 10 }],
      //         data: [
      //           {
      //             period: '1-6月',
      //             index: 1,
      //             blRate: 84,
      //             blRateStr: '84%',
      //             nbRate: 55.7,
      //             nbRateStr: '55.7%',
      //             zjRank: '8'
      //           },
      //           {
      //             period: '1-7月',
      //             index: 2,
      //             blRate: 86.5,
      //             blRateStr: '86.5%',
      //             nbRate: '/',
      //             nbRateStr: '/',
      //             zjRank: '19'
      //           },
      //           {
      //             period: '1-8月',
      //             index: 3,
      //             blRate: 77.4,
      //             blRateStr: '77.4%',
      //             nbRate: '/',
      //             nbRateStr: '/',
      //             zjRank: '44'
      //           }
      //         ],
      //         config: {
      //           columns: [
      //             { text: '序号', key: 'index' },
      //             { text: '时间', key: 'period' },
      //             {
      //               text: '增速',
      //               key: 'blRateStr',
      //               chartKey: 'blRate',
      //               type: 'line',
      //               yAxisIndex: 0,
      //               unit: '%',
      //               color: '#40de5a'
      //             },
      //             {
      //               text: '市增速',
      //               key: 'nbRateStr',
      //               chartKey: 'nbRate',
      //               type: 'line',
      //               yAxisIndex: 0,
      //               unit: '%',
      //               color: '#FC6F09'
      //             },
      //             { text: '省排名', key: 'zjRank' }
      //           ]
      //         }
      //       },
      //       {
      //         text: '专项债券总体支出进度',
      //         value: 52,
      //         dept: '区财政局',
      //         xAxis: {
      //           data: ['1-6月', '1-7月', '1-8月']
      //         },
      //         yAxis: [{ name: '增速(%)', max: 100, interval: 10 }],
      //         data: [
      //           {
      //             period: '1-6月',
      //             index: 1,
      //             blRate: 56.3,
      //             blRateStr: '56.3%',
      //             nbRate: 55.7,
      //             nbRateStr: '55.7%',
      //             zjRank: '55'
      //           },
      //           {
      //             period: '1-7月',
      //             index: 5,
      //             blRate: 92.7,
      //             blRateStr: '92.7%',
      //             nbRate: 91.5,
      //             nbRateStr: '91.5%',
      //             zjRank: '55'
      //           },
      //           {
      //             period: '1-8月',
      //             index: 6,
      //             blRate: 92.7,
      //             blRateStr: '92.7%',
      //             nbRate: 91.5,
      //             nbRateStr: '91.5%',
      //             zjRank: '66'
      //           }
      //         ],
      //         config: {
      //           columns: [
      //             { text: '序号', key: 'index' },
      //             { text: '时间', key: 'period' },
      //             {
      //               text: '增速',
      //               key: 'blRateStr',
      //               chartKey: 'blRate',
      //               type: 'line',
      //               yAxisIndex: 0,
      //               unit: '%',
      //               color: '#40de5a'
      //             },
      //             {
      //               text: '市增速',
      //               key: 'nbRateStr',
      //               chartKey: 'nbRate',
      //               type: 'line',
      //               yAxisIndex: 0,
      //               unit: '%',
      //               color: '#FC6F09'
      //             },
      //             { text: '省排名', key: 'zjRank' }
      //           ]
      //         }
      //       }
      //     ]
      //   },
      //   {
      //     text: '房地产报表',
      //     color: '#f00',
      //     value: 6,
      //     span: 11,
      //     children: [
      //       {
      //         text: '房地产开发投资',
      //         value: 61,
      //         dept: '区住建局',
      //         xAxis: {
      //           data: ['1-6月', '1-7月', '1-8月']
      //         },
      //         yAxis: [{ name: '增速(%)', max: 100, interval: 10 }],
      //         data: [
      //           {
      //             period: '1-6月',
      //             index: 1,
      //             blRate: 9.9,
      //             blRateStr: '9.9%',
      //             nbRate: 3.0,
      //             nbRateStr: '3.0%',
      //             zjRank: '36'
      //           },
      //           {
      //             period: '1-7月',
      //             index: 5,
      //             blRate: '/',
      //             blRateStr: '/',
      //             nbRate: 2.9,
      //             nbRateStr: '2.9%',
      //             zjRank: '36'
      //           },
      //           {
      //             period: '1-8月',
      //             index: 6,
      //             blRate: 9.7,
      //             blRateStr: '9.7%',
      //             nbRate: 3.1,
      //             nbRateStr: '3.1%',
      //             zjRank: '35'
      //           }
      //         ],
      //         config: {
      //           columns: [
      //             { text: '序号', key: 'index' },
      //             { text: '时间', key: 'period' },
      //             {
      //               text: '增速',
      //               key: 'blRateStr',
      //               chartKey: 'blRate',
      //               type: 'line',
      //               yAxisIndex: 0,
      //               unit: '%',
      //               color: '#40de5a'
      //             },
      //             {
      //               text: '市增速',
      //               key: 'nbRateStr',
      //               chartKey: 'nbRate',
      //               type: 'line',
      //               yAxisIndex: 0,
      //               unit: '%',
      //               color: '#FC6F09'
      //             },
      //             { text: '省排名', key: 'zjRank' }
      //           ]
      //         }
      //       },
      //       {
      //         text: '新建商品住宅销售面积',
      //         value: 62,
      //         dept: '区住建局',
      //         xAxis: {
      //           data: ['1-6月', '1-7月', '1-8月']
      //         },
      //         yAxis: [{ name: '增速(%)', max: 100, interval: 10 }],
      //         data: [
      //           {
      //             period: '1-6月',
      //             index: 1,
      //             blRate: 90.4,
      //             blRateStr: '90.4%',
      //             nbRate: '',
      //             nbRateStr: '',
      //             zjRank: '33'
      //           },
      //           {
      //             period: '1-7月',
      //             index: 5,
      //             blRate: 22.9,
      //             blRateStr: '22.9%',
      //             nbRate: '/',
      //             nbRateStr: '/',
      //             zjRank: '31'
      //           },
      //           {
      //             period: '1-8月',
      //             index: 6,
      //             blRate: 23.7,
      //             blRateStr: '23.7%',
      //             nbRate: '/',
      //             nbRateStr: '/',
      //             zjRank: '20'
      //           }
      //         ],
      //         config: {
      //           columns: [
      //             { text: '序号', key: 'index' },
      //             { text: '时间', key: 'period' },
      //             {
      //               text: '增速',
      //               key: 'blRateStr',
      //               chartKey: 'blRate',
      //               type: 'line',
      //               yAxisIndex: 0,
      //               unit: '%',
      //               color: '#40de5a'
      //             },
      //             {
      //               text: '市增速',
      //               key: 'nbRateStr',
      //               chartKey: 'nbRate',
      //               type: 'line',
      //               yAxisIndex: 0,
      //               unit: '%',
      //               color: '#FC6F09'
      //             },
      //             { text: '省排名', key: 'zjRank' }
      //           ]
      //         }
      //       },
      //       {
      //         text: '二手住宅成交面积',
      //         value: 63,
      //         dept: '区住建局',
      //         xAxis: {
      //           data: ['1-6月', '1-7月', '1-8月']
      //         },
      //         yAxis: [{ name: '增速(%)', min: -65, max: 100, interval: 10 }],
      //         data: [
      //           {
      //             period: '1-6月',
      //             index: 1,
      //             blRate: 31.7,
      //             blRateStr: '31.7%',
      //             nbRate: '',
      //             nbRateStr: '',
      //             zjRank: '21'
      //           },
      //           {
      //             period: '1-7月',
      //             index: 5,
      //             blRate: 18.1,
      //             blRateStr: '18.1%',
      //             nbRate: '/',
      //             nbRateStr: '/',
      //             zjRank: '26'
      //           },
      //           {
      //             period: '1-8月',
      //             index: 6,
      //             blRate: -60.5,
      //             blRateStr: '-60.5%',
      //             nbRate: '/',
      //             nbRateStr: '/',
      //             zjRank: '81'
      //           }
      //         ],
      //         config: {
      //           columns: [
      //             { text: '序号', key: 'index' },
      //             { text: '时间', key: 'period' },
      //             {
      //               text: '增速',
      //               key: 'blRateStr',
      //               chartKey: 'blRate',
      //               type: 'line',
      //               yAxisIndex: 0,
      //               unit: '%',
      //               color: '#40de5a'
      //             },
      //             {
      //               text: '市增速',
      //               key: 'nbRateStr',
      //               chartKey: 'nbRate',
      //               type: 'line',
      //               yAxisIndex: 0,
      //               unit: '%',
      //               color: '#FC6F09'
      //             },
      //             { text: '省排名', key: 'zjRank' }
      //           ]
      //         }
      //       }
      //     ]
      //   }
      // ]
      //#endregion
    
    }
  },
  async created() {
    const Wjtz = await getWjtz()
    console.log('地区生产总值+', Wjtz.data)
    this.WjtzDate = Wjtz.data
  },
  methods: {
    change(value) {
      this.value1 = this.value1 == value ? -1 : value
    },
    async clickItem(index) {
      this.option = {}
      this.dataTitle = ''
      if (index == this.value2) {
        this.value2 = 0
        this.isShowDiagram = false
        this.isNoData = true
      } else {
        this.value2 = index
        this.isShowDiagram = true
        var item = this.WjtzDate.find(x => x.value == this.value1).children.find(y => y.value == this.value2)
        this.dataTitle = item.text
        this.isNoData = item.isHide || false
        this.isShowDiagram = !this.isNoData
        item.data.forEach((value , index) => {
          value['index'] = index + 1
        })
        this.option = item
        console.log('option的数据+',this.option);
        if (!this.isNoData) {
          await this.$nextTick()
          this.initDiagram(item)
        }
      }
    },
    initDiagram(item) {
      console.log('图标的item数据+',item);
      var that = this
      //2.初始化
      const cElem = document.getElementById('charts')
      if (null != cElem) {
        that.chart = Echarts.init(cElem)
      }
      let option = {
        title: {
          text: item.text + '表',
          subtext: `监测部门：${item.dept}`,
          x: 'center',
          y: '10px',
          // textAlign:'left',
          subtextStyle: {}
        },
        grid: {
          top: '140px',
          left: '50px',
          right: '55px'
        },
        tooltip: {
          confine: true,
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        dataZoom: [
          //1.横向使⽤滚动条
          {
            type: 'slider',
            show: true,
            start: 0,
            end: 100,
            xAxisIndex: [0],
            bottom: 10 //距离底部的距离
          },
          //2.在内部可以横向拖动
          {
            type: 'inside',
            start: 0,
            end: 50,
            xAxisIndex: [0]
          },
          //3.纵向使⽤滚动条
          {
            type: 'slider',
            show: true,
            yAxisIndex: [0],
            left: '90%',
            start: 0,
            end: 100
          },
          //4.在内部可以纵向拖动
          {
            type: 'inside',
            yAxisIndex: [0],
            start: 29,
            end: 36
          }
        ],
        legend: {
          data: item.config.columns.filter(x => x.type).map(y => y.chartText || y.text),
          x: 'center',
          y: '60'
        },
        xAxis: [
          {
            type: 'category',
            data: item.xAxis.data,
            axisPointer: {
              type: 'shadow'
            },
            axisLabel: {
              interval: 0,
              rotate: 40
            }
          }
        ],
        yAxis: item.yAxis.map(x => {
          return {
            type: 'value',
            name: x.name,
            min: x.min || 0,
            // 省重大项目新建项目开工率 max 值小了，改大了 
            max: x.max == 80 ? 90 : x.max || 100,
            interval: x.interval == 8 ? 9 :x.interval || 10,
            axisLabel: {
              formatter: '{value}'
            },
            nameLocation: item.value == '40' || item.value == '23' ? 'start' : 'end',
            inverse:item.value == '40' || item.value == '23' ? true : false
          }
        }),
        series: item.config.columns.filter(x => x.type).map(y => {
          console.log('看看筛选之后的columns',item.config.columns.filter(x => x.type).map(y => y.chartText || y.text));
          console.log('看看y数据+',y);
            return {
              name: y.chartText || y.text,
              type: y.type,
              yAxisIndex: y.yAxisIndex,
              color: y.color,
              tooltip: {
                valueFormatter: function(value) {
                  return value + ` ${y.unit}`
                }
              },
              data:item.data.map(z => z[y.chartKey || y.key]),
              itemStyle: {
                normal: {
                  label: {
                    show: false,
                    position: 'top',
                    textStyle: {
                      color: '#000000',
                      fontSize: 18 //字体大小
                    }
                  }
                }
              }
            }
          })
      }
      setTimeout(() => {
        if (null != that.chart) {
          that.chart.setOption(option, true)
        }
      }, 100)
    }
  }
}
</script>

<style scoped>
.month {
  padding: 10px;
  margin-top: 40px;
  box-shadow: 0 0 5px #aaa;
  border-radius: 5px;
}
.card1 {
  background-color: #ffffff;
  border-radius: 5px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.van-dropdown-menu >>> .van-dropdown-menu__bar {
  background-color: rgba(0, 0, 0, 0);
}
.van-dropdown-menu >>> .van-ellipsis {
  color: #ffffff;
  font-size: 18px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Wjtz-component1.vue